import { render } from "./future.vue?vue&type=template&id=4b157bd4&scoped=true"
import script from "./future.vue?vue&type=script&lang=js"
export * from "./future.vue?vue&type=script&lang=js"

import "./future.vue?vue&type=style&index=0&id=4b157bd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b157bd4"

export default script